import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { Global, ThemeProvider } from '@emotion/react'
import { getTheme } from '@yuno/sdk-web-core/dist/theme/theme'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { resetCss } from './styles'
import { QueryProvider } from './state'
import './i18n'
import { loadScript } from '@yuno-payments/sdk-web'
import { getGeolocationIfEnabled } from './utils/geolocation'
import { getWhiteLabelOptions } from './utils/white-label'
import { useTranslation } from 'react-i18next'

const RTLWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation()
  return <div dir={i18n.dir()}>{children}</div>
}
const whiteLabelOptions = getWhiteLabelOptions()
loadScript({
  env: process.env.REACT_APP_SDK_WEB_ENV as any || 'prod',
  // Match the SDK's own `assetUrl ?? apiUrl` asset-host contract: when a merchant
  // proxies everything under one host and passes apiUrl alone (or assetUrl is
  // dropped by the allowlist), the bundle must still load from the proxy, not
  // Yuno's CDN, which a CSP-locked merchant page would block.
  baseUrl: whiteLabelOptions?.assetUrl ?? whiteLabelOptions?.apiUrl,
})

console.log('checkout-version: ', process.env.REACT_APP_VERSION)

const theme = getTheme()

const App = () => {
  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <Global styles={[resetCss]} />
        <QueryProvider>
          <RTLWrapper>
            <RouterProvider router={router} />
          </RTLWrapper>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryProvider>
      </ThemeProvider>
    </React.StrictMode>
  )
}

getGeolocationIfEnabled().then((position) => {
  if (position) {
    console.log('position', position)
  }
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)

reportWebVitals()
